import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { CallState, Funnel } from "redmond";
import { PaymentCard } from "./component";
import {
  verifyPaymentMethod,
  listPaymentMethods,
  deletePaymentMethod,
  setSelectedPaymentMethodId,
  fetchProductToEarn,
  fetchAllEarnForProduct,
} from "../../actions/actions";
import {
  getDeletePaymentMethodCallState,
  getListPaymentMethodsCallState,
  getPaymentMethods,
  getVerifyPaymentMethodCallState,
  getSelectedPaymentMethodId,
  getTotalCreditCardPaymentRequired,
  getIsCreditCardPaymentRequired,
  getRewardsPaymentAccount,
  getRewardsPaymentAccountReferenceId,
  getHasError,
  getIsStackedTravelWalletPaymentOnly,
  getIsTravelWalletCreditPaymentOnly,
  getIsTravelWalletOfferPaymentOnly,
  getVacationRentalsIsStackedTravelWalletPaymentOnly,
  getVacationRentalsIsTravelWalletCreditPaymentOnly,
  getVacationRentalsIsTravelWalletOfferPaymentOnly,
  getVacationRentalsIsCreditCardPaymentRequired,
  getTotalVacationRentalsCreditCardPaymentRequired,
  getOfferToApply,
  getEarnValuesByRewardAcctId,
  getApplicableCredit,
  getOffers,
  getFetchApplicableTravelWalletItemsCallState,
} from "../../reducer";
import {
  getAllowRewardsWithPolicy,
  getRewardsAccounts,
} from "../../../rewards/reducer";
import { fetchRewardsAccounts } from "../../../rewards/actions/actions";
import { IStoreState } from "../../../../reducers/types";
import {
  getPremierCollectionShopSelectedAvailability,
  getIsChosenRoomPayLater,
  getChosenRoomHasPayLater,
  getIsLifestyleEligible,
} from "../../../shop/reducer";
import { getVacationRentalShopSelectedListing } from "../../../vacation-rental-shop/reducer";
import { getAllTravelWalletOffers } from "../../../travel-wallet/reducer";
import { getConfigTenant, isCorpTenant, hasIneligibleTravelOffer } from "@capone/common";

const mapStateToProps = (state: IStoreState) => {
  const selectedHome = getVacationRentalShopSelectedListing(state);
  const applicableOffers = getOffers(state);
  const allWalletOffers = getAllTravelWalletOffers(state);
  const hasIneligibleFTB =
    isCorpTenant(getConfigTenant()) &&
    hasIneligibleTravelOffer(
      allWalletOffers,
      applicableOffers ?? [],
      selectedHome ? Funnel.Home : Funnel.Lodging
    );

  const hasOffersOrCredits =
    (applicableOffers && applicableOffers.length > 0) ||
    Boolean(getApplicableCredit(state)) ||
    hasIneligibleFTB;

  return {
    paymentMethods: getPaymentMethods(state),
    rewardsAccounts: getRewardsAccounts(state),
    listPaymentMethodCallState: getListPaymentMethodsCallState(state),
    verifyPaymentMethodCallState: getVerifyPaymentMethodCallState(state),
    deletePaymentMethodCallState: getDeletePaymentMethodCallState(state),
    selectedPaymentMethodId: getSelectedPaymentMethodId(state),
    selectedRewardsPaymentAccount: getRewardsPaymentAccount(state),
    selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
    isCreditCardPaymentRequired: selectedHome
      ? getVacationRentalsIsCreditCardPaymentRequired(state)
      : getIsCreditCardPaymentRequired(state),
    totalCreditCardPaymentRequired: selectedHome
      ? getTotalVacationRentalsCreditCardPaymentRequired(state)
      : getTotalCreditCardPaymentRequired(state),
    hasError: getHasError(state),
    isStackedTravelWalletPaymentOnly: selectedHome
      ? getVacationRentalsIsStackedTravelWalletPaymentOnly(state)
      : getIsStackedTravelWalletPaymentOnly(state),
    isTravelCreditPaymentOnly: selectedHome
      ? getVacationRentalsIsTravelWalletCreditPaymentOnly(state)
      : getIsTravelWalletCreditPaymentOnly(state),
    isTravelWalletOfferPaymentOnly: selectedHome
      ? getVacationRentalsIsTravelWalletOfferPaymentOnly(state)
      : getIsTravelWalletOfferPaymentOnly(state),
    selectedLodging: getPremierCollectionShopSelectedAvailability(state),
    selectedHome: selectedHome,
    canRedeemRewards: getAllowRewardsWithPolicy(state),
    offerToApply: getOfferToApply(state),
    earnValuesByRewardAcctId: getEarnValuesByRewardAcctId(state),
    isPayLater: getIsChosenRoomPayLater(state),
    hasPayLater: getChosenRoomHasPayLater(state),
    isLifestyleEligible: getIsLifestyleEligible(state),
    credits: getApplicableCredit(state),
    filteredOffers: getOffers(state),
    walletLoaded:
      getFetchApplicableTravelWalletItemsCallState(state) === CallState.Success,
    canUseTravelWallet: hasOffersOrCredits,
  };
};

const mapDispatchToProps = {
  verifyPaymentMethod,
  listPaymentMethods,
  deletePaymentMethod,
  setSelectedPaymentMethodId,
  fetchRewardsAccounts,
  fetchProductToEarn,
  fetchAllEarnForProduct,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PaymentCardConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPaymentCard = withRouter(connector(PaymentCard));
